import { PropsWithChildren } from "react";

type MarkupColors = "yellow" | "grey" | "black";

interface BaseMarkupProps extends PropsWithChildren {
  background?: boolean;
  color: MarkupColors;
  className?: string;
}

const TEXT_CLASSES: Record<MarkupColors, string> = Object.freeze({
  yellow: "text-custom-yellow-500",
  grey: "text-custom-gray-100",
  black: "text-custom-black"

});

const BACKGROUND_CLASSES: Record<MarkupColors, string> = Object.freeze({
  yellow: "p-1 text-white bg-custom-yellow-500",
  grey: "p-1 text-white bg-custom-gray-100",
  black: "px-2 py-1 text-white bg-custom-black"
});

export function Markup({
  color,
  background,
  className,
  ...props
}: BaseMarkupProps) {
  const colorClass = background
    ? BACKGROUND_CLASSES[color]
    : TEXT_CLASSES[color];

  return (
    <div
      {...props}
      className={`${colorClass} rounded-sm mt-1 font-chivo-bold text-xs ${className}`}
    />
  );
}
